import React from 'react';
import { 
  CheckCircleIcon, 
  ExclamationTriangleIcon, 
  XCircleIcon, 
  ClipboardDocumentIcon 
} from '@heroicons/react/24/solid';

const ProgressBar = ({ green, yellow, red, white, total, legendPosition = 'below' }) => {
  const calculatePercentage = (value) => Math.round((value / total) * 100);
  
  const greenPercentage = calculatePercentage(green);
  const yellowPercentage = calculatePercentage(yellow);
  const redPercentage = calculatePercentage(red);
  const whitePercentage = calculatePercentage(white);

  const Legend = () => (
    <div className={`grid ${legendPosition === 'right' ? 'grid-cols-1 gap-1' : 'grid-cols-4 gap-2'} text-xs`}>
      <div className="flex items-center justify-center gap-1">
        <CheckCircleIcon className="w-4 h-4 text-success" />
        <span>{greenPercentage}%</span>
      </div>
      <div className="flex items-center justify-center gap-1">
        <ExclamationTriangleIcon className="w-4 h-4 text-warning" />
        <span>{yellowPercentage}%</span>
      </div>
      <div className="flex items-center justify-center gap-1">
        <XCircleIcon className="w-4 h-4 text-error" />
        <span>{redPercentage}%</span>
      </div>
      <div className="flex items-center justify-center gap-1">
        <ClipboardDocumentIcon className="w-4 h-4 text-base-content/60" />
        <span>{whitePercentage}%</span>
      </div>
    </div>
  );

  return (
    <div className={`${legendPosition === 'right' ? 'flex gap-4 items-center' : 'space-y-2'}`}>
      {/* Combined Progress Bar */}
      <div className={`${legendPosition === 'right' ? 'w-32' : 'w-full'} h-2 sm:h-3 rounded-full overflow-hidden bg-base-200 relative`}>
        <div 
          className="h-full absolute left-0 bg-success transition-all duration-300"
          style={{ width: `${greenPercentage}%` }} 
        />
        <div 
          className="h-full absolute bg-warning transition-all duration-300"
          style={{ 
            left: `${greenPercentage}%`,
            width: `${yellowPercentage}%` 
          }} 
        />
        <div 
          className="h-full absolute bg-error transition-all duration-300"
          style={{ 
            left: `${greenPercentage + yellowPercentage}%`,
            width: `${redPercentage}%` 
          }} 
        />
        <div 
          className="h-full absolute bg-base-300 transition-all duration-300"
          style={{ 
            left: `${greenPercentage + yellowPercentage + redPercentage}%`,
            width: `${whitePercentage}%` 
          }} 
        />
      </div>
      
      {/* Legend */}
      <Legend />
    </div>
  );
};

export default ProgressBar; 